import React from 'react';
import { Row, Col, Card, Nav, Badge, Container } from 'react-bootstrap';
import ListingCreative from 'components/ListingCreative';
import style from './style.module.scss';
import { useTranslation } from 'react-i18next';

const NavCreative = ({
  statuses,
  data,
  filters,
  stateFilters,
  handleFilterChange,
  actions
}) => {
  const { t } = useTranslation();

  const handleSelect = status_id =>
    handleFilterChange({ status_id, page: 1 }, true);

  return (
    <>
      <Row>
        <Col>
          <Container className="shadow bg-white rounded">
            <Card.Body className={style.statuses}>
              <Nav
                variant="pills"
                activeKey={stateFilters.status_id}
                onSelect={handleSelect}
              >
                {statuses.map((status, k) => (
                  <Nav.Item key={k}>
                    <Nav.Link key={k} eventKey={status.id}>
                      {t(`statuses:${status.name}`)}
                      <Badge variant="light">{status.count}</Badge>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Card.Body>
          </Container>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <ListingCreative
            {...{ data, filters, stateFilters, handleFilterChange, actions }}
          />
        </Col>
      </Row>
    </>
  );
};

export default NavCreative;
